// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mx-0";